import {
  Bars3Icon,
  BugAntIcon,
  ChartBarIcon,
  Cog6ToothIcon,
  HomeIcon,
  LightBulbIcon,
  PuzzlePieceIcon,
  QuestionMarkCircleIcon,
  UserGroupIcon,
} from "@heroicons/react/24/outline";
import { getPagePath } from "@nanostores/router";
import { ReactElement } from "react";

import { $router } from "../stores/router";
import { Dropdown } from "./catalyst/Dropdown";
import { DropdownButton } from "./catalyst/DropdownButton";
import { DropdownItem } from "./catalyst/DropdownItem";
import { DropdownMenu } from "./catalyst/DropdownMenu";
import { DropdownSection } from "./catalyst/DropdownSection";

export const GraphMenuIcon = (): ReactElement => {
  const handleHelpItemClick = (action: string): void => {
    if (action === "help") {
      window.open(
        "https://miru-labs.gitbook.io/miru/y0ukxYqBXl34AjvGB60x/",
        "_blank",
        "noopener,noreferrer",
      );
    }
    // TODO: Implement actual help actions for other cases
  };

  return (
    <Dropdown>
      <DropdownButton
        as="button"
        className="ring-.75 flex items-center justify-center rounded-lg bg-zinc-900/90 p-4 shadow-lg ring-zinc-600 hover:bg-zinc-800/90"
      >
        <Bars3Icon className="h-5 w-5 text-zinc-400" />
      </DropdownButton>
      <DropdownMenu anchor="bottom start" className="z-[60] min-w-48">
        <DropdownSection aria-label="Navigation">
          <DropdownItem
            className="!justify-start font-normal data-[hover]:!bg-white/10 hover:!bg-white/10 focus:!bg-white/10 active:!bg-white/10"
            href={getPagePath($router, "index")}
          >
            <HomeIcon className="h-4 w-4" />
            <span>Workspaces</span>
          </DropdownItem>
          <DropdownItem
            className="!justify-start font-normal data-[hover]:!bg-white/10 hover:!bg-white/10 focus:!bg-white/10 active:!bg-white/10"
            href={getPagePath($router, "integrations")}
          >
            <PuzzlePieceIcon className="h-4 w-4" />
            <span>Integrations</span>
          </DropdownItem>
          <DropdownItem
            className="!justify-start font-normal data-[hover]:!bg-white/10 hover:!bg-white/10 focus:!bg-white/10 active:!bg-white/10"
            href={getPagePath($router, "entities")}
          >
            <UserGroupIcon className="h-4 w-4" />
            <span>Entities</span>
          </DropdownItem>
          <DropdownItem
            className="!justify-start font-normal data-[hover]:!bg-white/10 hover:!bg-white/10 focus:!bg-white/10 active:!bg-white/10"
            href={getPagePath($router, "dashboard")}
          >
            <ChartBarIcon className="h-4 w-4" />
            <span>Dashboard</span>
          </DropdownItem>
          <DropdownItem
            className="!justify-start font-normal data-[hover]:!bg-white/10 hover:!bg-white/10 focus:!bg-white/10 active:!bg-white/10"
            href={getPagePath($router, "settings")}
          >
            <Cog6ToothIcon className="h-4 w-4" />
            <span>Settings</span>
          </DropdownItem>
        </DropdownSection>
        <DropdownSection aria-label="Help">
          <DropdownItem
            className="!justify-start font-normal data-[hover]:!bg-white/10 hover:!bg-white/10 focus:!bg-white/10 active:!bg-white/10"
            onClick={() => handleHelpItemClick("help")}
          >
            <QuestionMarkCircleIcon className="h-4 w-4" />
            <span>Help & Resources</span>
          </DropdownItem>
          <DropdownItem
            className="!justify-start font-normal data-[hover]:!bg-white/10 hover:!bg-white/10 focus:!bg-white/10 active:!bg-white/10"
            onClick={() => handleHelpItemClick("bug")}
          >
            <BugAntIcon className="h-4 w-4" />
            <span>Report a bug</span>
          </DropdownItem>
          <DropdownItem
            className="!justify-start font-normal data-[hover]:!bg-white/10 hover:!bg-white/10 focus:!bg-white/10 active:!bg-white/10"
            onClick={() => handleHelpItemClick("feature")}
          >
            <LightBulbIcon className="h-4 w-4" />
            <span>Suggest a feature</span>
          </DropdownItem>
        </DropdownSection>
      </DropdownMenu>
    </Dropdown>
  );
};
